import palette from "assets/theme/base/palette";
import React, { useCallback } from "react";
import { useState, useEffect } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DefaultProjectCard from "examples/Cards/ProjectCards/DefaultProjectCard";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import Loader from "pages/loader/Loader";
import { Card } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CancelPresentationIcon from "@mui/icons-material/CancelPresentation";
import ReactPlayer from "react-player";
import MaxuLogo from "assets/images/nav-logo.png";
import { useMaterialUIController } from "context";
import { call } from "services/axiosService/core";
import * as Sentry from "@sentry/browser";
import ContentPlayerDialog from "examples/Dialog/ContentPlayerDialog";
import NoContent from "pages/NoContent";
import { useTranslation } from "react-i18next";

const PlayList = () => {
  const [controller] = useMaterialUIController();
  const { profile, persona } = controller;
  const [playList, setPlayList] = useState([]);
  const [contents, setContents] = useState([]);
  const [content, setContent] = useState({});
  const [playContent, setPlayContent] = useState(false);
  const [userMetricsData, setUserMetricsData] = useState(null);
  const [likedContent, setLikedContent] = useState([]);
  const [dislikedContent, setDislikedContent] = useState([]);
  const [savedContent, setSavedContent] = useState([]);
  const [viewedContent, setViewedContent] = useState([]);
  const [recommendedContent, setRecommendedContent] = useState([]);
  const [loading, setLoading] = useState(true);
  const [noContent, setNoContent] = useState(false);
  const [contentFilter, setContentFilter] = useState("all");
  const [mediaFilter, setMediaFilter] = useState("all");
  const [searchFilter, setSearchFilter] = useState("");
  const { t } = useTranslation();

  useEffect(() => {
    loadUserContentMetrics();
  }, [profile]);

  useEffect(() => {
    getUserPlayList();
  }, []);

  const loadUserContentMetrics = () => {
    call(`users/${profile.id}/contentmetrics`, "GET", {})
      .then((res) => {
        // console.log("res ", res);
        if (res.status == 200) {
          let data = res.data;
          setUserMetricsData(data);
          setLikedContent([...data.likedcontent]);
          setDislikedContent([...data.dislikedcontent]);
          setViewedContent([...data.viewedcontent]);
          setSavedContent([...data.savedcontent]);
          setRecommendedContent([...data.recommendedcontent]);
        } else if (res.status == 440) {
          console.log("expired");
        }
      })
      .catch((err) => {
        console.log(err);
        Sentry.captureException(err);
      });
  };

  const getUserPlayList = () => {
    setLoading(true);
    call(`users/${profile.id}/playlist`, "GET", {})
      .then((res) => {
        if (res.status == 200) {
          if (res.data.length == 0) {
            setNoContent(true);
          }
          setContents([...res.data]);
          setPlayList([...res.data]);
          setLoading(false);
        } else if (res.status == 440) {
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        setNoContent(true);
        console.log(err);
        Sentry.captureException(err);
      });
  };

  const likeHandler = (title) => {
    let eventkey = { event: "likecontent", value: title };
    var currentlikedContent = [...likedContent];
    var currentdislikedContent = [...dislikedContent];
    currentlikedContent.push(title);
    // if content in disliked array remove it from there
    if (currentdislikedContent.includes(title)) {
      const index = currentdislikedContent.indexOf(title);
      currentdislikedContent.splice(index, 1);
      eventkey = { event: "likecontent-removedislike", value: title };
    }
    let metricData = userMetricsData;
    metricData["likedcontent"] = [...currentlikedContent];
    metricData["dislikedcontent"] = [...currentdislikedContent];
    metricData["eventkey"] = eventkey;

    call(`users/${profile.id}/contentmetrics`, "PUT", { body: metricData })
      .then((res) => {
        if (res.status == 200) {
          setLikedContent([...currentlikedContent]);
          setDislikedContent([...currentdislikedContent]);
          setUserMetricsData(metricData);
        }
      })
      .catch((err) => {
        console.log(err);
        Sentry.captureException(err);
      });
  };

  const dislikeHandler = (title) => {
    let eventkey = { event: "dislikecontent", value: title };
    var currentlikedContent = [...likedContent];
    var currentdislikedContent = [...dislikedContent];
    currentdislikedContent.push(title);
    // if content in liked array remove it from there
    if (currentlikedContent.includes(title)) {
      const index = currentlikedContent.indexOf(title);
      currentlikedContent.splice(index, 1);
      eventkey = { event: "dislikecontent-removelike", value: title };
    }
    let metricData = userMetricsData;
    metricData["likedcontent"] = [...currentlikedContent];
    metricData["dislikedcontent"] = [...currentdislikedContent];
    metricData["eventkey"] = eventkey;
    call(`users/${profile.id}/contentmetrics`, "PUT", { body: metricData })
      .then((res) => {
        if (res.status == 200) {
          setDislikedContent([...currentdislikedContent]);
          setLikedContent([...currentlikedContent]);
          setUserMetricsData(metricData);
        }
      })
      .catch((err) => {
        console.log(err);
        Sentry.captureException(err);
      });
  };

  const removeLikeHandler = (title) => {
    let eventkey = { event: "removelikecontent", value: title };

    var currentlikedContent = [...likedContent];
    const index = currentlikedContent.indexOf(title);
    currentlikedContent.splice(index, 1);
    let metricData = userMetricsData;
    metricData["likedcontent"] = [...currentlikedContent];
    metricData["eventkey"] = eventkey;
    call(`users/${profile.id}/contentmetrics`, "PUT", { body: metricData })
      .then((res) => {
        if (res.status == 200) {
          setLikedContent([...currentlikedContent]);
          setUserMetricsData(metricData);
        }
      })
      .catch((err) => {
        console.log(err);
        Sentry.captureException(err);
      });
  };

  const removeDislikeHandler = (title) => {
    let eventkey = { event: "removedislikecontent", value: title };
    var currentdislikedContent = [...dislikedContent];
    const index = currentdislikedContent.indexOf(title);
    currentdislikedContent.splice(index, 1);
    let metricData = userMetricsData;
    metricData["dislikedcontent"] = [...currentdislikedContent];
    metricData["eventkey"] = eventkey;
    call(`users/${profile.id}/contentmetrics`, "PUT", { body: metricData })
      .then((res) => {
        if (res.status == 200) {
          setDislikedContent([...currentdislikedContent]);
          setUserMetricsData(metricData);
        }
      })
      .catch((err) => {
        console.log(err);
        Sentry.captureException(err);
      });
  };

  const saveHandler = (title) => {
    let eventkey = { event: "savedcontent", value: title };
    let allcontents = [...contents];
    let playlist = [...playList];
    let currentSavedContent = [...savedContent];
    let currentRecommendContent = [...recommendedContent];
    let metricData = userMetricsData;
    if (currentSavedContent.includes(title)) {
      const index = currentSavedContent.indexOf(title);
      currentSavedContent.splice(index, 1);
      eventkey = { event: "removeSaved", value: title };
      if (!currentRecommendContent.includes(title)) {
        allcontents.splice(
          allcontents.findIndex((a) => a.title === title),
          1
        );
        playlist.splice(
          playlist.findIndex((a) => a.title === title),
          1
        );
        if (allcontents.length == 0) {
          setNoContent(true);
        }
      } else {
        if (contentFilter == "saved") {
          allcontents.splice(
            allcontents.findIndex((a) => a.title === title),
            1
          );
        }
      }
    } else {
      currentSavedContent.push(title);
    }
    metricData["savedcontent"] = [...currentSavedContent];
    metricData["eventkey"] = eventkey;
    call(`users/${profile.id}/contentmetrics`, "PUT", { body: metricData })
      .then((res) => {
        if (res.status == 200) {
          setSavedContent([...currentSavedContent]);
          setUserMetricsData(metricData);
          setContents(allcontents);
          setPlayList(playlist);
        }
      })
      .catch((err) => {
        console.log(err);
        Sentry.captureException(err);
      });
  };

  const getContentLinkHandler = (item) => {
    call(`content/${item.title}`, "GET", {})
      .then((res) => {
        if (res.status == 200) {
          setPlayContent(true);
          setContent(res.data);
        }
      })
      .catch((err) => {
        console.log("error is", err);
        Sentry.captureException(err);
      });
  };

  const closeContentPlayer = () => {
    setPlayContent(false);
  };

  const getSavedContent = () => {
    let currentSavedContent = [...savedContent];
    let CuttentPlayList = [...playList];
    let newList = CuttentPlayList.filter((item) => {
      return currentSavedContent.includes(item.title);
    });
    setContents([...newList]);
    if (newList.length == 0) {
      setNoContent(true);
    } else {
      setNoContent(false);
    }
  };

  const getRecommendContent = () => {
    let currentRecommendContent = [...recommendedContent];
    let CuttentPlayList = [...playList];
    let newList = CuttentPlayList.filter((item) => {
      return currentRecommendContent.includes(item.title);
    });
    setContents([...newList]);
    if (newList.length == 0) {
      setNoContent(true);
    } else {
      setNoContent(false);
    }
  };

  const getAllContent = () => {
    setContents([...playList]);
    if (playList.length == 0) {
      setNoContent(true);
    } else {
      setNoContent(false);
    }
  };

  const displayedContents = contents
    .filter((item) => mediaFilter === "all" || item.content_type?.toLowerCase() === mediaFilter.toLowerCase())
    .filter((item) => !searchFilter || item.title?.toLowerCase().includes(searchFilter.toLowerCase()));

  const tabs = [
    { key: "all", label: t("playList.buttonTitles.myContent"), icon: "bookmarks" },
    { key: "saved", label: t("playList.buttonTitles.savedContent"), icon: "bookmark" },
    { key: "recommend", label: t("playList.buttonTitles.recommendedContent"), icon: "star" },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar title={t("pageTitles.myContent")} />

      <MDBox mt={3}>
        {/* ── Tab row ── */}
        <Card sx={{ mb: 2 }}>
          <MDBox px={2.5} py={2} display="flex" flexWrap="wrap" gap={1}>
            {tabs.map(({ key, label, icon }) => {
              const active = contentFilter === key;
              return (
                <MDBox
                  key={key}
                  onClick={() => {
                    setContentFilter(key);
                    if (key === "all") getAllContent();
                    else if (key === "saved") getSavedContent();
                    else getRecommendContent();
                  }}
                  sx={{
                    flex: "1 1 110px",
                    minWidth: 0,
                    display: "flex", alignItems: "center", justifyContent: "center", gap: 0.6,
                    py: 0.8,
                    borderRadius: "10px",
                    border: `1.5px solid ${active ? palette.brand[500] : palette.neutral[300]}`,
                    bgcolor: active ? palette.brand[500] : "#fff",
                    cursor: "pointer",
                    transition: "all 180ms ease",
                    "&:hover": { borderColor: palette.brand[400], bgcolor: active ? palette.brand[500] : palette.brand[50] },
                  }}
                >
                  <Icon sx={{ color: active ? "#fff" : palette.neutral[500], fontSize: "16px !important" }}>{icon}</Icon>
                  <MDTypography variant="caption" fontWeight="medium" sx={{ color: active ? "#fff" : "text.primary" }}>
                    {label}
                  </MDTypography>
                </MDBox>
              );
            })}
          </MDBox>
        </Card>

        {/* ── Filter row ── */}
        <Card sx={{ mb: 2 }}>
          <MDBox px={2.5} py={2}>
            {/* Search + label row */}
            <MDBox display="flex" alignItems="center" justifyContent="space-between" mb={1.5}>
              {/* <MDTypography variant="caption" fontWeight="bold" sx={{ color: "text.secondary" }}>
                Media Type
              </MDTypography> */}
              <TextField
                size="small"
                placeholder="Search..."
                value={searchFilter}
                onChange={(e) => setSearchFilter(e.target.value)}
                sx={{ width: { xs: "100%", sm: 300 } }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Icon sx={{ fontSize: "16px !important", color: palette.neutral[400] }}>search</Icon>
                    </InputAdornment>
                  ),
                  sx: { fontSize: "0.8rem" },
                }}
              />
            </MDBox>

            {/* Media type pills */}
            <MDBox display="flex" flexWrap="wrap" gap={1}>
              {["all", "Video", "Article", "Worksheet", "Infographic"].map((type) => {
                const active = mediaFilter === type;
                const icons = { all: "apps", Video: "play_circle", Article: "article", Worksheet: "note", Infographic: "leaderboard" };
                return (
                  <MDBox
                    key={type}
                    onClick={() => setMediaFilter(type)}
                    sx={{
                      flex: "1 1 90px",
                      minWidth: 0,
                      display: "flex", alignItems: "center", justifyContent: "center", gap: 0.5,
                      py: 0.8,
                      borderRadius: "10px",
                      border: `1.5px solid ${active ? palette.brand[500] : palette.neutral[300]}`,
                      bgcolor: active ? palette.brand[500] : "#fff",
                      cursor: "pointer",
                      transition: "all 180ms ease",
                      "&:hover": { borderColor: palette.brand[400], bgcolor: active ? palette.brand[500] : palette.brand[50] },
                    }}
                  >
                    <Icon sx={{ color: active ? "#fff" : palette.neutral[600], fontSize: "16px !important" }}>{icons[type]}</Icon>
                    <MDTypography variant="caption" fontWeight="medium" sx={{ color: active ? "#fff" : "text.primary" }}>
                      {type === "all" ? "All Media" : type}
                    </MDTypography>
                  </MDBox>
                );
              })}
            </MDBox>
          </MDBox>
        </Card>

        {/* ── Content grid ── */}
        {displayedContents.length > 0 ? (
          <Grid container spacing={3}>
            {displayedContents.map((item, index) => {
              let icon = "movie";
              const content_type = item.content_type?.toLowerCase();
              if (content_type === "video") icon = "movie";
              else if (content_type === "infographic") icon = "leaderboard";
              else if (content_type === "article") icon = "article";
              else if (content_type === "worksheet") icon = "note";
              return (
                <Grid item xs={12} md={4} key={index}>
                  <DefaultProjectCard
                    item={item}
                    icon={icon}
                    type={item.content_type}
                    title={item.title}
                    shareable={false}
                    content_url={item.content_url}
                    image={item.thumbnail_url || MaxuLogo}
                    getContentLinkHandler={getContentLinkHandler}
                    liked={likedContent.includes(item.title)}
                    disliked={dislikedContent.includes(item.title)}
                    saved={savedContent.includes(item.title)}
                    viewed={viewedContent.includes(item.title)}
                    likeHandler={likeHandler}
                    dislikeHandler={dislikeHandler}
                    removeLikeHandler={removeLikeHandler}
                    removeDislikeHandler={removeDislikeHandler}
                    saveHandler={saveHandler}
                    action={{
                      type: "external",
                      route: item.content_url,
                      color: "info",
                      label: t("buttonTitles.view"),
                    }}
                  />
                </Grid>
              );
            })}
          </Grid>
        ) : !loading && (
          <NoContent
            title={t("playList.noContentAvailable")}
            subtitle={t("playList.contactSupport")}
            icon="bookmarks"
            iconColor="#9c27b0"
          />
        )}
      </MDBox>

      {playContent && (
        <ContentPlayerDialog
          playContent={playContent}
          closeContentPlayer={closeContentPlayer}
          content={content}
          userMetricsData={userMetricsData}
          setUserMetricData={setUserMetricsData}
          setViewedContent={setViewedContent}
          userId={profile.id}
          t={t}
        />
      )}

      {loading && (
        <Dialog open={loading} fullScreen>
          <DialogContent>
            <Loader loaderText={t("loaderText.loadingContent")} />
          </DialogContent>
        </Dialog>
      )}
    </DashboardLayout>
  );
};

export default PlayList;
